
import { ElePage } from './../pages/ele/ele';
import { ElesPage } from './../pages/eles/eles';
import { Autoresize } from './../components/ion-textarea-autoresize';
import { KeyValueFilterPipe } from './../pipes/key-value-filter-pipe';

import { NgModule, ErrorHandler } from '@angular/core';
import { HttpModule, JsonpModule } from '@angular/http'
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { MyApp } from './app.component';

import { TabsPage } from '../pages/tabs/tabs';

import { AttachLicidPage } from './../pages/attach-licid/attach-licid';
import { InfoLicidPage } from './../pages/info-licid/info-licid';
import { InfoCloudPage } from './../pages/info-cloud/info-cloud';
import { InfoCloudDetailPage } from './../pages/info-cloud-detail/info-cloud-detail';
import { OthersPage } from './../pages/others/others';
import { UsersPage } from './../pages/users/users';
import { UserPage } from './../pages/user/user';
import { CloudsPage } from './../pages/clouds/clouds';
import { CloudPage } from './../pages/cloud/cloud';
import { DebugPage } from './../pages/debug/debug';

import { AboutPage } from '../pages/about/about';
import { HomePage } from '../pages/home/home';

 
import { Login } from '../pages/login/login';

import {ResetPassword}from '../pages/reset-password/reset-password';
import {Signup} from '../pages/signup/signup';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Tracking } from './../providers/tracking';
import { AuthData } from '../providers/auth-data';
import { MyFirebase } from '../providers/my-firebase';
import { ApiV1 } from '../providers/api-v1';
import { ToastMessage } from './../providers/toast-message';
import { UploadButtonComponent } from '../components/upload-button/upload-button';
import { ModelMetier } from '../providers/model-metier';
import { MyLayoutStdComponent } from '../components/my-layout-std/my-layout-std';


@NgModule({
  declarations: [
    MyApp,
    ElesPage,
    ElePage,
    AttachLicidPage,
    InfoLicidPage,
    InfoCloudPage,
    InfoCloudDetailPage,
    OthersPage,
    CloudsPage,
    CloudPage,
    UsersPage,
    UserPage,
    DebugPage,
    
AboutPage,
HomePage,
    
    TabsPage,
      Login,
      ResetPassword,
      Signup,

    KeyValueFilterPipe,
    UploadButtonComponent,
    Autoresize,
    MyLayoutStdComponent

  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/ele/ele.module#ElePageModule', name: 'ElePage', segment: 'ele', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/eles/eles.module#ElesPageModule', name: 'ElesPage', segment: 'eles', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/cloud/cloud.module#CloudPageModule', name: 'CloudPage', segment: 'cloud', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/clouds/clouds.module#CloudsPageModule', name: 'CloudsPage', segment: 'clouds', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/user/user.module#UserPageModule', name: 'UserPage', segment: 'user', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/info-cloud-detail/info-cloud-detail.module#InfoCloudDetailPageModule', name: 'InfoCloudDetailPage', segment: 'info-cloud-detail', priority: 'low', defaultHistory: [] }
  ]
}),
    IonicStorageModule.forRoot(),
    HttpModule,
    JsonpModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    ElesPage,
    ElePage,
    AttachLicidPage,
    InfoLicidPage,
    InfoCloudPage,
    InfoCloudDetailPage,
    OthersPage,
    CloudsPage,
    CloudPage,
    UsersPage,
    UserPage,
    DebugPage,
MyLayoutStdComponent,
AboutPage,
HomePage,
      TabsPage,
      Login,
      ResetPassword,
      Signup
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},

    Tracking,
    AuthData,
    MyFirebase,
    ModelMetier,
    ApiV1,
    ToastMessage,
  ]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts